export default __webpack_public_path__ + "static/media/yulim.1e2dcc3b.png";